var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState } from "react";
export var editingReportDataOptions = {
    initialReportName: null,
    seenSteps: {
        has: function () { return true; },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        add: function () { },
    },
};
var ReportDataContext = createContext(undefined);
export var ReportDataProvider = function (_a) {
    var children = _a.children, initial = _a.initial;
    var _b = useState(initial || {}), reportData = _b[0], setReportData = _b[1];
    return (_jsx(ReportDataContext.Provider, __assign({ value: { reportData: reportData, setReportData: setReportData } }, { children: children })));
};
export var useReportData = function () {
    var context = useContext(ReportDataContext);
    if (!context) {
        // Return a no-op version for components not wrapped in ReportDataProvider
        return {
            reportData: {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            setReportData: (function () { }),
        };
    }
    return context;
};
